import React, { createContext, useCallback, useContext, useState } from 'react'
import VppaModal from '../../../components/VppaModal'
import {
  OnCloseCallbackType,
  VppaContextType,
  VppaProviderProps,
} from '../hooks/types'

const VppaContext = createContext<VppaContextType | undefined>(undefined)

const VppaProvider = ({ children }: VppaProviderProps) => {
  const [isVppaModalOpen, setIsVppaModalOpen] = useState(false)
  const [isVppaModalChecked, setIsVppaModalChecked] = useState(false)
  const [onCloseCallback, setOnCloseCallback] =
    useState<OnCloseCallbackType | null>(null)

  const openVppaModal = useCallback((onClose: OnCloseCallbackType) => {
    setOnCloseCallback(() => onClose)
    setIsVppaModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(
    (args: { accepted: boolean; declined?: boolean }) => {
      if (onCloseCallback) {
        onCloseCallback(args)
      }
      setIsVppaModalOpen(false)
      setOnCloseCallback(null)
    },
    [onCloseCallback]
  )

  const contextValue = {
    openVppaModal,
    isVppaModalOpen,
    setIsVppaModalChecked,
    isVppaModalChecked,
  }

  return (
    <VppaContext.Provider value={contextValue}>
      {children}
      {isVppaModalOpen && <VppaModal onCloseModal={handleCloseModal} />}
    </VppaContext.Provider>
  )
}

export const useVppaModalProvider = () => {
  const context = useContext(VppaContext)

  if (!context) {
    throw new Error('useVppaContext must be used within a VppaProvider')
  }

  return context
}

export default VppaProvider
